import { MoveWorkerCompanyNeedCommands } from '@/modules/companyNeed/types/moveWorker';
import { CompanyNeedWorkerStatus } from '@/modules/companyNeed/types/worker';

export const KANBAN_COLUMN_COMMANDS: Record<
	number,
	MoveWorkerCompanyNeedCommands
> = {
	0: MoveWorkerCompanyNeedCommands.MOVE_TO_PREQUALIFIED,
	1: MoveWorkerCompanyNeedCommands.MOVE_TO_CONTACTED,
	2: MoveWorkerCompanyNeedCommands.MOVE_TO_INTERVIEW,
	3: MoveWorkerCompanyNeedCommands.MOVE_TO_COMPANY_PROPOSED,
	4: MoveWorkerCompanyNeedCommands.MOVE_TO_COMPANY_INTERVIEW,
	5: MoveWorkerCompanyNeedCommands.MOVE_TO_MISSION_PROPOSED,
};

export const MOVE_COMMAND_TO_WORKER_STATUS: Partial<
	Record<MoveWorkerCompanyNeedCommands, CompanyNeedWorkerStatus>
> = {
	[MoveWorkerCompanyNeedCommands.MOVE_TO_PREQUALIFIED]:
		CompanyNeedWorkerStatus.PREQUALIFIED,
	[MoveWorkerCompanyNeedCommands.MOVE_TO_CONTACTED]:
		CompanyNeedWorkerStatus.CONTACTED,
	[MoveWorkerCompanyNeedCommands.MOVE_TO_INTERVIEW]:
		CompanyNeedWorkerStatus.INTERVIEW,
	[MoveWorkerCompanyNeedCommands.MOVE_TO_COMPANY_INTERVIEW]:
		CompanyNeedWorkerStatus.COMPANY_INTERVIEW,
	[MoveWorkerCompanyNeedCommands.MOVE_TO_COMPANY_PROPOSED]:
		CompanyNeedWorkerStatus.COMPANY_PROPOSED,
	[MoveWorkerCompanyNeedCommands.MOVE_TO_MISSION_PROPOSED]:
		CompanyNeedWorkerStatus.MISSION_PROPOSED,
};
